/**
 * 文件导入相关的枚举定义
 * 用于替代魔法数字，提高代码可读性和可维护性
 */

/**
 * 文件类型枚举
 */
export enum FileType {
  /** 音频文件 */
  AUDIO = 0,
  /** 视频文件 */
  VIDEO = 1,
}

/**
 * 导入状态枚举
 */
export enum ImportStatus {
  /** 等待上传 */
  WAIT_UPLOAD = -2,
  /** 上传中 */
  UPLOADING = -1,
  /** 等待转写 */
  WAITING = 0,
  /** 转写中 */
  TRANSING = 1,
  /** 转写错误 */
  TRANS_ERROR = 2,
  /** 转写成功 */
  TRANS_SUCCESS = 3,
  /** 取消转写 */
  CANCEL = 4,
  /** 上传失败 */
  UPLOAD_ERROR = 10,
  /** 新增错误 */
  ADD_ERROR = 11,
}

/**
 * 导入状态工具函数
 */
export const ImportStatusUtils = {
  /**
   * 判断是否为上传相关状态（status < 0）
   */
  isUploadStatus: (status: number): boolean => {
    return status < 0;
  },

  /**
   * 判断是否为转写相关状态（status >= 0）
   */
  isTransformStatus: (status: number): boolean => {
    return status >= 0;
  },

  /**
   * 判断是否为错误状态
   */
  isErrorStatus: (status: number): boolean => {
    return status === ImportStatus.TRANS_ERROR ||
           status === ImportStatus.UPLOAD_ERROR ||
           status === ImportStatus.ADD_ERROR;
  },

  /**
   * 判断是否为可重试状态
   */
  isRetryableStatus: (status: number): boolean => {
    return status === ImportStatus.TRANS_ERROR ||
           status === ImportStatus.UPLOAD_ERROR ||
           status === ImportStatus.ADD_ERROR;
  },

  /**
   * 判断是否为完成状态（成功或取消）
   */
  isCompletedStatus: (status: number): boolean => {
    return status === ImportStatus.TRANS_SUCCESS ||
           status === ImportStatus.CANCEL;
  },

  /**
   * 判断是否为进行中状态
   */
  isInProgressStatus: (status: number): boolean => {
    return status === ImportStatus.WAIT_UPLOAD ||
           status === ImportStatus.UPLOADING ||
           status === ImportStatus.WAITING ||
           status === ImportStatus.TRANSING;
  },
};
